import React, { memo, useEffect, useState } from 'react';
import moment from 'moment';
import guaranteedIcon from '../../assets/images/guaranteed-icon.svg';
import { ReactComponent as Orientation } from '../../assets/images/badge-orientation.svg';
import Select from '../../components/form/Select';

const SLOT_LIMIT = 20;
const SLOT_OPTIONS = Array.from(Array(SLOT_LIMIT), (o, i) => ({ label: i + 1, value: i + 1 }));

const AddSlots = (props) => {
	const { shift, isGlobalCalendar, allSlotsAreGuaranteed } = props;
	const [duration, setDuration] = useState(null);
	const [shiftDate, setShiftDate] = useState(null);

	useEffect(() => {
		// raw_start_time is shift.start_time AT TIME ZONE facility.timezone
		// on the server node-postgres calls new Date() on the date string returned by the postgres server
		// Because the local time zone of the server is UTC, the date string returned by postgres is then converted
		// to UTC at the hour returned by postgres. Timezone info is lost
		// calling just moment(...) here applies the local browser time zone
		// this means that depending on the time zone, you can either end up with
		// - a date on the previous day when local browser timezone is GMT -x
		// - a date on the next day when local timezone is GMT +x
		// using moment.utc prevents additional time conversions and fixes the issue
		const end = moment.utc(shift.raw_end_time);
		const start = moment.utc(shift.raw_start_time);
		setDuration(end.diff(start, 'hours', true));
		setShiftDate(start.format('MM/DD'));
	}, [shift]);

	return (
		<>
			<p className="title-slots">Would you like to add a new {shift.slots[0].resource_type} to this shift?</p>
			<table className="table shifts-confirmation-table">
				<thead className="header-confirmation-shifts d-none d-sm-flex">
					<tr className="header-confirmation-shifts-row">
						<th className="head-text">{shift.slots[0].resource_type}(s) needed</th>
						<th className="head-text">Day</th>
						<th className="head-text">Date</th>
						<th className="head-text">Start Time</th>
						<th className="head-text">End Time</th>
						<th className="head-text">Hours</th>
						<th className="head-text">Feature</th>
					</tr>
				</thead>
				<tbody>
					<tr className="row-confirmation-shifts slots" key={`add-slot-details-${shift.id}`}>
						<td className="row-shift add-shift">
							<Select
								options={SLOT_OPTIONS}
								value={props.numberOfSlots}
								name="numberOfSlots"
								containerClass="select-add-shift"
								handleChange={(e) => props.setNumberOfSlots(e.numberOfSlots)}
							/>
						</td>
						<td className="row-shift add-shift">
							<div>{shift.slots[0].shift_day.substr(0, 3)}</div>
						</td>
						<td className="row-shift add-shift">
							<div>{shiftDate}</div>
						</td>
						<td className="row-shift add-shift">
							<div>{shift.start_time}</div>
						</td>
						<td className="row-shift add-shift">
							<div>{shift.end_time}</div>
						</td>
						<td className="row-shift add-shift">
							<div>{duration}</div>
						</td>
						<td className="row-shift add-shift">
							{((isGlobalCalendar && allSlotsAreGuaranteed) || (!isGlobalCalendar && shift.shift_guaranteed)) && (
								<span className="guaranteed-badge-span slot mb-2">
									<img className="guaranteed-icon" src={guaranteedIcon} alt="Guaranteed shift" />
									Guaranteed
								</span>
							)}
							{shift.is_orientation && (
								<div className="guaranteed-badge-span orientation">
									<Orientation className="orientation-icon" />
									<span>Orientation</span>
								</div>
							)}
						</td>
					</tr>
				</tbody>
			</table>
		</>
	);
};

export default memo(AddSlots);
